import { render } from "./OffersSlick.vue?vue&type=template&id=0c2dd92a"
import script from "./OffersSlick.vue?vue&type=script&lang=js"
export * from "./OffersSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/OffersSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c2dd92a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c2dd92a', __exports__)) {
    api.reload('0c2dd92a', __exports__)
  }
  
  module.hot.accept("./OffersSlick.vue?vue&type=template&id=0c2dd92a", () => {
    api.rerender('0c2dd92a', render)
  })

}


export default __exports__